module.exports = __webpack_public_path__ + "img/vehicle-risk.23beca23.png";